import React from "react";
import { Helmet } from "react-helmet";

const AboutMe = () => {
  return (
    <section
      className="px-4 pb-3 w-full max-w-[100vw]"
      id="aboutme"
      data-aos="fade-up"
    >
      <Helmet>
        <title>About Me - Your Name</title>
        <meta name="description" content="Brief description about yourself." />
      </Helmet>
      <article>
        <header>
          <h2 className="text-3xl font-light">
            <span className="bg-green-400 rounded-lg py-1 text-3xl">About Me</span>
          </h2>
        </header>
        <div className="text-lg font-thin pt-3 lg:text-xl">
          Hello, and welcome to my portfolio! My name is Aklesh, and I am an
          aspiring web developer and hobbyist game developer. I believe that
          technology has the power to connect people and transform lives, and I am
          passionate about creating meaningful digital experiences that make a
          difference in people's lives. My journey into the world of coding began
          as a hobby, but I quickly realized that this was my calling. With a
          background in CS, I have honed my skills in html, css, tailwind,
          javascript including react. I enjoy learning about new technologies and
          tools that can enhance my work and help me build better experiences for
          my users. I am committed to creating clean, user-friendly interfaces
          that make navigating complex systems a breeze. From responsive design to
          accessibility, I take ensure that every aspect of a website is carefully
          considered to deliver the best possible user experience. But beyond my
          technical skills, I am also a creative problem-solver with a passion for
          collaboration. I believe that the best solutions come from working
          together, and I always strive to bring a positive attitude and a
          willingness to learn to every project I'm a part of. When I'm not coding
          or designing, you can find me playing video games, reading and watching
          shows. I'm also an avid reader and enjoy learning about new subjects.
          Thank you for taking the time to learn more about me. If you're
          interested in collaborating on a project or just want to say hello,
          don't hesitate to reach out!
        </div>
      </article>
    </section>
  );
};

export default AboutMe;
